import { cva, type VariantProps } from "class-variance-authority";
import type Flex from "@/components/layout/Flex";
import type Typography from "@/components/shared/Typography";
import type { ExtendProps } from "@/lib/types";
import { cls } from "@/lib/utils";

export type CardProps = ExtendProps<
  typeof Flex,
  VariantProps<typeof cardVariants>
>;

export type CardContentProps = ExtendProps<typeof Flex>;

export type CardDescriptionProps = ExtendProps<typeof Typography.P>;

export type CardFooterProps = ExtendProps<typeof Flex>;

export type CardHeaderProps = ExtendProps<typeof Flex>;

export type CardTitleProps = ExtendProps<typeof Typography.H2>;

export const cardVariants = cva(cls`rounded-sm shadow-lg`, {
  defaultVariants: {
    variant: "default",
  },
  variants: {
    variant: {
      default: cls`bg-card text-card-foreground`,
      secondary: cls`bg-card-secondary text-card-secondary-foreground`,
      tertiary: cls`bg-card-tertiary text-card-tertiary-foreground`,
      transparent: cls`bg-transparent border-none text-card-foreground`,
    },
  },
});
